<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#1976d2"
      size="128"
      is-full-screen
    />
    <v-snackbar v-model="showSnackbar" color="black" right>
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center>
      <v-flex px-0 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <v-card flat min-height="100vh">
          <v-card-title class="elevation-1">
            <span v-if="$route.query.Type == 'grocerydeals'"> Deals </span>
            <!-- <span v-else-if="$route.query.Type == 'SmallBanner'">
              Small Banner
            </span>
            <span v-else-if="$route.query.Type == 'ProductBanner'">
              Product Banner
            </span>
            <span v-else> Bottom Banner </span> -->

            <v-spacer></v-spacer>
            <v-flex md2>
              <v-dialog
                :retain-focus="false"
                v-model="dialog"
                persistent
                max-width="800px"
                :key="dialog"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    outlined
                    color="green"
                    width="100%"
                    v-bind="attrs"
                    v-on="on"
                  >
                    Add
                  </v-btn>
                </template>
                <v-card>
                  <v-form v-model="addslider" ref="addcat">
                    <v-card-title>
                      <span class="headline">Add Deals</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="12" md="12">
                            <v-text-field
                              label="Deal Name"
                              v-model="offerData.name"
                            >
                            </v-text-field>
                          </v-col>
                          <v-col
                            cols="12"
                            sm="12"
                            md="12"
                            v-if="$route.query.Type == 'ProductBanner'"
                          >
                            <v-autocomplete
                              item-text="varientName"
                              item-value="productId._id"
                              label="Product List"
                              v-model="offerData.productId"
                              :items="productList"
                            >
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-autocomplete
                              v-model="offerData.categoryId"
                              :items="categoryList"
                              @change="getProduct(offerData.categoryId)"
                              :rules="[rules.required]"
                              item-text="name"
                              item-value="_id"
                              color="#B1B1B1"
                              hide-details
                              placeholder="Category"
                              label="Category"
                              @input="getSubCategory(offerData.categoryId)"
                            ></v-autocomplete>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-autocomplete
                              v-model="offerData.subcategoryId"
                              :items="SubcategoryList"
                              item-text="name"
                              item-value="_id"
                              color="#B1B1B1"
                              clearable
                              placeholder="Sub Category"
                              label="Sub Category"
                            ></v-autocomplete>
                          </v-col>
                          <v-col cols="12" sm="12" md="12" class="text-left">
                            <span class="homeText">
                              Description of the deal</span
                            >
                            <div id="app" class="pt-3">
                              <vue-editor
                                v-model="offerData.description"
                              ></vue-editor>
                            </div>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-menu
                              ref="menu"
                              v-model="menu"
                              :close-on-content-click="false"
                              :return-value.sync="offerData.startingDate"
                              transition="scale-transition"
                              offset-y
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="offerData.startingDate"
                                  :rules="[rules.required]"
                                  label="Select Staring Date"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="offerData.startingDate"
                                no-title
                                scrollable
                              >
                                <v-spacer></v-spacer>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="menu = false"
                                >
                                  Cancel
                                </v-btn>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="
                                    $refs.menu.save(offerData.startingDate)
                                  "
                                >
                                  OK
                                </v-btn>
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-menu
                              ref="menu1"
                              v-model="menu1"
                              :close-on-content-click="false"
                              :return-value.sync="offerData.endingDate"
                              transition="scale-transition"
                              offset-y
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  :rules="[rules.required]"
                                  v-model="offerData.endingDate"
                                  label="Select Ending Date"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="offerData.endingDate"
                                no-title
                                scrollable
                              >
                                <v-spacer></v-spacer>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="menu1 = false"
                                >
                                  Cancel
                                </v-btn>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="
                                    $refs.menu1.save(offerData.endingDate)
                                  "
                                >
                                  OK
                                </v-btn>
                              </v-date-picker>
                            </v-menu>
                          </v-col>

                          <v-col cols="12" sm="12" md="12">
                            <v-switch
                              color="yellow"
                              label="Is this Deal is based on Discount"
                              v-model="isForDiscount"
                            >
                            </v-switch>
                          </v-col>

                          <v-col cols="12" sm="6" md="6" class="pl-2">
                            <v-text-field
                              label=" Statring Price"
                              v-model="offerData.priceFrom"
                              :disabled="isForDiscount != false ? true : false"
                            >
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="6" class="pl-2">
                            <v-text-field
                              label=" Max Price Limit"
                              v-model="offerData.priceTo"
                              :disabled="isForDiscount != false ? true : false"
                            >
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="6" class="pl-2">
                            <v-text-field
                              label="Min Discount (%)"
                              v-model="offerData.discountFrom"
                              :disabled="isForDiscount == false ? true : false"
                            >
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="6" class="pl-2">
                            <v-text-field
                              label="Max Discount (%)"
                              v-model="offerData.discountTo"
                              :disabled="isForDiscount == false ? true : false"
                            >
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" sm="12" md="12">
                            <ImageComp
                              @stepper="winStepper"
                              :height="'2'"
                              :width="'3'"
                              :heading="'Upload Offer Image '"
                              :componentType="'DealImage'"
                            />
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="dialogclose()">
                        Close
                      </v-btn>
                      <v-btn
                        color="blue darken-1"
                        text
                        :disabled="!addslider"
                        @click="add()"
                      >
                        Save
                      </v-btn>
                    </v-card-actions>
                  </v-form>
                </v-card>
              </v-dialog>
            </v-flex>
          </v-card-title>
          <div v-if="offerList.length > 0">
            <v-layout wrap justify-start v-if="offerList.length > 0">
              <v-flex v-for="(item, i) in offerList" :key="i" md6 pa-4>
                <v-card style="line-height: 16px">
                  <v-layout wrap pa-3>
                    <v-flex md4 px-2 style="border: 3px solid grey">
                      <img
                        v-if="item.photo"
                        v-viewer
                        style="
                          width: 100%;
                          object-fit: contain;
                          cursor: pointer;
                        "
                        :src="baseURL + '/file/get/' + item.photo"
                        height="180px"
                      />
                      <v-img
                        v-else
                        style="
                          width: 100%;
                          object-fit: contain;
                          cursor: pointer;
                        "
                        src="../../assets/images/no-image.png"
                        height="180px"
                        contain
                      >
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                          >
                            <v-progress-circular
                              indeterminate
                              color="#FF2323"
                            ></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-flex>
                    <v-flex md8>
                      <v-layout wrap justify-left text-left px-2>
                        <v-flex xs12 pt-1 text-right>
                          <v-btn
                            @click="changeDealStatus(item._id)"
                            v-if="item.status == 'Active'"
                            color="green"
                            dark
                            x-small
                            style="text-transform: none"
                          >
                            Active
                          </v-btn>
                          <v-btn
                            @click="changeDealStatus(item._id)"
                            v-if="item.status == 'Inactive'"
                            color="grey"
                            dark
                            x-small
                            style="text-transform: none"
                          >
                            Inactive
                          </v-btn>
                        </v-flex>
                        <v-flex xs12 pt-1>
                          <span
                            style="
                              font-size: 18px;
                              color: #000000;
                              font-weight: bold;
                            "
                          >
                            {{ item.name }}
                          </span>
                        </v-flex>
                        <v-flex xs12 pt-1>
                          <span
                            style="
                              font-size: 12px;
                              color: #000000;
                              font-weight: bold;
                            "
                            v-html="item.description"
                          >
                          </span>
                        </v-flex>
                        <v-flex pr-3>
                          <v-divider></v-divider>
                        </v-flex>
                        <v-flex xs12 pt-2>
                          <span style="font-size: 12px; color: #000000"
                            >Offer validity:</span
                          >
                          <br />
                          <span
                            class="showLine"
                            style="font-size: 13px; color: #000000"
                          >
                            <span style="font-weight: bold">
                              {{ formatDate(item.starting) }}
                              {{ formatTime(item.startingTime) }} to
                              {{ formatDate(item.ending) }}
                              {{ formatTime(item.endingTime) }}
                            </span>
                          </span>
                        </v-flex>
                        <v-flex xs12 pt-1>
                          <span
                            v-if="item.categoryId"
                            style="font-size: 12px; color: #000000"
                          >
                            <b> Category: </b> {{ item.categoryId.name }}
                          </span>
                        </v-flex>
                        <v-flex xs12 pt-1>
                          <span
                            v-if="item.subcategoryId"
                            style="font-size: 12px; color: #000000"
                          >
                            <b> Sub Category: </b>{{ item.subcategoryId.name }}
                          </span>
                        </v-flex>

                        <v-flex xs6 pt-1 v-if="item.priceFrom">
                          <span style="font-size: 12px; color: #000000">
                            Price From:
                          </span>
                          <b> {{ item.priceFrom }} </b>
                        </v-flex>
                        <v-flex xs6 pt-1 v-if="item.priceTo">
                          <span style="font-size: 12px; color: #000000">
                            Price to:
                          </span>
                          <b> {{ item.priceTo }} </b>
                        </v-flex>
                        <v-flex xs6 pt-1 v-if="item.discountFrom">
                          <span style="font-size: 12px; color: #000000">
                            Discont From:
                          </span>
                          <b> {{ item.discountFrom }} </b> %
                        </v-flex>
                        <v-flex xs6 pt-1 v-if="item.discountTo">
                          <span style="font-size: 12px; color: #000000">
                            Discount to:
                          </span>
                          <b> {{ item.discountTo }} </b> %
                        </v-flex>
                        <br />
                      </v-layout>
                    </v-flex>
                    <v-flex xs12>
                      <v-layout text-right>
                        <v-flex pt-2 px-1 xs6>
                          <v-btn
                            @click="(editdialog = true), editFunc(item)"
                            x-small
                            class="mr-2"
                            outlined
                            block
                            color="primary"
                          >
                            Edit
                          </v-btn>
                        </v-flex>

                        <v-flex pt-2 px-1 xs6 align-self-end>
                          <v-dialog v-model="item.delete" max-width="600px">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                x-small
                                class="mr-2"
                                outlined
                                block
                                v-on="on"
                                v-bind="attrs"
                                color="red"
                              >
                                Delete
                              </v-btn>
                            </template>
                            <v-card>
                              <v-card-title
                                >Are you sure you want to delete this
                                Banner?</v-card-title
                              >
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="blue darken-1"
                                  text
                                  @click="item.delete = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="blue darken-1"
                                  text
                                  @click="deleteItem(item)"
                                  >OK</v-btn
                                >
                                <v-spacer></v-spacer>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </div>
          <div v-else>
            <v-layout pt-15 justify-center fill-height wrap>
              <v-flex text-center xs12 lg12>
                <span style="font-size: 22px; letter-spacing: 1px">
                  No Data Found...
                </span>
              </v-flex>
            </v-layout>
          </div>
          <v-dialog v-model="editdialog" max-width="800px">
            <v-card>
              <v-card-title>
                <span class="headline">Edit Deal</span>
              </v-card-title>
              <v-card-text>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field
                      label="Banner Name"
                      v-model="editingitem.name"
                    >
                    </v-text-field>
                  </v-flex>

                  <v-flex xs12 v-if="$route.query.Type == 'ProductBanner'">
                    <v-autocomplete
                      item-text="varientName"
                      item-value="productId._id"
                      label="Product List"
                      v-model="editingitem.productId"
                      :items="productList"
                    >
                    </v-autocomplete>
                  </v-flex>
                  <v-flex xs12 md6>
                    <!-- {{editingitem.categoryId}} -->
                    <v-autocomplete
                      v-model="editingitem.categoryId"
                      :items="categoryList"
                      @change="getProduct(editingitem.categoryId)"
                      :rules="[rules.required]"
                      item-text="name"
                      item-value="_id"
                      color="#B1B1B1"
                      hide-details
                      placeholder="Category"
                      label="Category"
                      @input="getSubCategory(editingitem.categoryId)"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 md6 pl-0 pl-sm-4>
                    <v-autocomplete
                      v-model="editingitem.subcategoryId"
                      :items="SubcategoryList"
                      item-text="name"
                      item-value="_id"
                      clearable
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 text-left>
                    <span class="homeText">Description of the Offer</span>
                    <div id="app" class="pt-3">
                      <vue-editor
                        v-model="editingitem.description"
                      ></vue-editor>
                    </div>
                  </v-flex>
                </v-layout>
                <v-layout wrap pt-3>
                  <v-flex xs12 md6>
                    <v-menu
                      ref="menu5"
                      v-model="menu5"
                      :close-on-content-click="false"
                      :return-value.sync="editingitem.startingDate"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="editingitem.startingDate"
                          label="Select Date"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="editingitem.startingDate"
                        no-title
                        scrollable
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="menu5 = false">
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.menu5.save(editingitem.startingDate)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-menu
                      ref="menu6"
                      v-model="menu6"
                      :close-on-content-click="false"
                      :return-value.sync="editingitem.endingDate"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="editingitem.endingDate"
                          label="Select Date"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="editingitem.endingDate"
                        no-title
                        scrollable
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="menu6 = false">
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.menu6.save(editingitem.endingDate)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                </v-layout>
                <v-layout wrap pt-3>
                  <v-flex xs12>
                    <v-switch
                      color="yellow"
                      label="Is this Deal is based on Discount"
                      v-model="isForDiscount"
                    >
                    </v-switch>
                  </v-flex>
                  <v-flex xs12 md6 pr-1>
                    <v-text-field
                      label=" Statring Price"
                      v-model="editingitem.priceFrom"
                      :disabled="isForDiscount != false ? true : false"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 md6 pl-1>
                    <v-text-field
                      label=" Max Price Limit"
                      v-model="editingitem.priceTo"
                      :disabled="isForDiscount != false ? true : false"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 md6 pr-1>
                    <v-text-field
                      label="Min Discount (%)"
                      v-model="editingitem.discountFrom"
                      :disabled="isForDiscount == false ? true : false"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 md6 pl-1>
                    <v-text-field
                      label="Max Discount (%)"
                      v-model="editingitem.discountTo"
                      :disabled="isForDiscount == false ? true : false"
                    >
                    </v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex xs12 md12 lg12>
                    <ImageComp
                      :singleImage="editingitem.offerImage"
                      :pageId="editingitem._id"
                      @stepper="winStepper"
                      :height="9"
                      :width="16"
                      :heading="'Upload offer Image '"
                      :componentType="'DealImage'"
                    />
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="editdialog = false">
                  Close
                </v-btn>
                <v-btn color="blue darken-1" text @click="edit()"> Save </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card>
        <!-- <div class="text-center pb-5">
          <v-pagination
            :length="pages"
            :total-visible="8"
            v-model="currentPage"
            color="#FDAC53"
          ></v-pagination>
        </div> -->
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import ImageComp from "@/components/Common/singleImage";
import { VueEditor } from "vue2-editor";
export default {
  components: {
    VueEditor,
    ImageComp,
  },
  data() {
    return {
      editDialog: false,
      DealImage: null,
      SubcategoryList: [],

      isForDiscount: false,
      deals: [],
      productList: [],
      ServerError: false,
      widthOfCard: "250px",
      rot: 0,
      menu: false,
      menu1: false,
      menu3: false,
      menu4: false,
      menu5: false,
      menu6: false,
      menu7: false,
      menu8: false,
      products: [],
      offerData: {
        startingDate: new Date().toISOString().substr(0, 10),
        endingDate: new Date().toISOString().substr(0, 10),
      },

      formDataCover: new FormData(),
      offerImage: null,
      showSnackbar: false,
      msg: null,
      pages: 0,
      appLoading: false,
      currentPage: 1,
      totalData: 0,
      totalRows: 0,
      delete: false,
      dialogDelete: false,
      dialog: false,
      dialog1: false,
      editdialog: false,
      editingitem: [],
      offerList: [],
      data: [],
      addslider: false,
      imgId: "",
      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        num: (value) => (value < 100 && value >= 0) || "Must be between 0-100",
      },
      Rules: [(value) => !!value || "Required."],
      titleRule: [(v) => v.length < 50 || "Min 50 characters"],
      sellers: [],
      categoryList: [],
    };
  },

  mounted() {
    this.getData();
    this.getCategory();
    this.getProducts();
  },
  // watch: {
  //   rot() {
  //     if (this.rot > 360) this.rot = 0;
  //   },
  // },
  methods: {
    changeDealStatus(item) {
      this.appLoading = true;
      axios({
        url: "/grocery/admin/deal/status/change",
        method: "post",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          id: item,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.appLoading = false;
            this.showSnackbar = true;
            this.msg = response.data.msg;
            this.getData();
          } else {
            this.appLoading = false;
            this.showSnackbar = true;
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    editFunc(item) {
      console.log("items==", item);
      this.editingitem.name = item.name;
      this.editingitem.categoryId = item.categoryId._id;
      this.getSubCategory(this.editingitem.categoryId);
      this.editingitem.subcategoryId = item.subcategoryId._id;
      this.editingitem.description = item.description;
      this.editingitem.startingDate = item.name;
      this.editingitem.endingDate = item.ending.slice(0, 10);
      this.editingitem.startingDate = item.starting.slice(0, 10);
      this.editingitem.priceFrom = item.priceFrom;
      this.editingitem.priceTo = item.priceTo;
      this.editingitem.discountFrom = item.discountFrom;
      this.editingitem.discountTo = item.discountTo;
      this.editingitem.offerImage = item.photo;
      this.editingitem.Id = item._id;
    },
    getProduct(sellerId) {
      console.log(sellerId);
      this.appLoading = true;
      axios({
        url: "/grocery/subcategory/list/" + sellerId,
        method: "get",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.deals = response.data.data;
            this.totalCount = response.data.totalLength;
            // this.pages = response.data.pages;
            this.appLoading = false;
          } else {
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    winStepper(window_data) {
      this.DealImage = window_data.selectedFiles;
      console.log(" this.DealImage===", this.DealImage);
    },
    getData() {
      let getURL;
      if (this.$route.query.Type == "grocerydeals") {
        getURL = "/grocery/admin/getall/deal/list";
      }
      //   } else if (this.$route.query.Type == "SmallBanner") {
      //     getURL = "/grocery/admin/small/banner/list";
      //   } else if (this.$route.query.Type == "ProductBanner") {
      //     getURL = "/grocery/admin/product/banner/list";
      //   } else {
      //     getURL = "/grocery/admin/bottam/banner/list";
      //   }

      this.appLoading = true;
      axios({
        url: getURL,
        method: "get",
        headers: {
          token: localStorage.getItem("token"),
        },
        params: {
          limit: 50,
          page: this.currentPage,
        },
      })
        .then((response) => {
          this.offerList = response.data.data;
          this.pages = Math.ceil(response.data.totalPages / 50);
          this.appLoading = false;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    getProducts() {
      // this.appLoading = true;
      axios({
        method: "post",
        url: "/grocery/admin/products/list",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            {
              this.productList = response.data.product;

              // this.appLoading = false;
            }
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    getCategory() {
      this.appLoading = true;
      axios({
        method: "get",
        url: "/grocery/category/list/62b16b36fdd907192c69f476",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            {
              this.categoryList = response.data.data;
              this.appLoading = false;
            }
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    getSubCategory(val) {
      this.appLoading = true;
      axios({
        method: "get",
        url: "/grocery/subcategory/list/" + val,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            {
              this.SubcategoryList = response.data.data;
              this.appLoading = false;
            }
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    add() {
      this.appLoading = true;

      let getURL;
      if (this.$route.query.Type == "grocerydeals") {
        getURL = "/grocery/admin/add/deal";
      }
      // } else if (this.$route.query.Type == "SmallBanner") {
      //   getURL = "/grocery/admin/small/banner/add";
      // } else if (this.$route.query.Type == "ProductBanner") {
      //   getURL = "/grocery/admin/product/banner/add";
      // } else {
      //   getURL = "/grocery/admin/bottam/banner/add";
      // }
      axios({
        url: getURL,
        method: "POST",
        data: this.offerData,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.imgId = response.data.id;
            if (this.DealImage != null) this.uploadImage(response.data.id);
            // this.getData();
            this.msg = "Added Sucessfully";
            this.showSnackbar = true;
            Object.keys(this.offerData).forEach(
              (key) => (this.offerData[key] = null)
            );
            this.link = null;
            this.title = null;
            this.caption = null;
            this.date = null;
            this.imagePreview = null;
            this.file = null;
            this.dialog = false;
          } else {
            this.msg = response.data.msg;
            this.showSnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    edit() {
      let getURL;
      if (this.$route.query.Type == "grocerydeals") {
        getURL = "/grocery/admin/edit/deal";
      }

      this.appLoading = true;

      this.formDataCover.append("name", this.editingitem.name);
      this.formDataCover.append("categoryId", this.editingitem.categoryId);

      if (this.editingitem.subcategoryId) {
        this.formDataCover.append(
          "subcategoryId",
          this.editingitem.subcategoryId
        );
      }

      this.formDataCover.append("description", this.editingitem.description);
      this.formDataCover.append("startingDate", this.editingitem.startingDate);
      this.formDataCover.append("startingTime", this.editingitem.startingTime);
      this.formDataCover.append("endingDate", this.editingitem.endingDate);
      this.formDataCover.append("priceFrom", this.editingitem.priceFrom);
      this.formDataCover.append("priceTo", this.editingitem.priceTo);
      this.formDataCover.append("discountFrom", this.editingitem.discountFrom);
      this.formDataCover.append("discountTo", this.editingitem.discountTo);
      // this.formDataCover.append("photo", this.offerImage);
      this.formDataCover.append("id", this.editingitem.Id);

      var editData = {};
      editData["name"] = this.editingitem.name;
      editData["categoryId"] = this.editingitem.categoryId;
      editData["description"] = this.editingitem.description;
      editData["startingDate"] = this.editingitem.startingDate;
      editData["endingDate"] = this.editingitem.endingDate;
      editData["priceFrom"] = this.editingitem.priceFrom;
      editData["priceTo"] = this.editingitem.priceTo;
      editData["discountFrom"] = this.editingitem.discountFrom;
      editData["discountTo"] = this.editingitem.discountTo;
      editData["id"] = this.editingitem.Id;

      console.log("editData=", editData);

      axios({
        method: "POST",
        url: getURL,
        headers: {
          //  "Content-Type": "multipart/form-data",
          token: localStorage.getItem("token"),
        },
        // data: this.formDataCover,
        data: editData,
      })
        .then((response) => {
          this.appLoading = false;

          if (response.data.status) {
            this.editData = {};
            if (this.DealImage != null) this.uploadImage(response.data.id);
            this.editdialog = false;
            this.formDataCover = new FormData();

            this.msg = response.data.msg;
            this.showSnackbar = true;
            this.getData();
          } else {
            this.msg = "Can't Update";
            this.showSnackbar = true;
            this.formDataCover = new FormData();
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    editSlider(item) {
      this.editingitem = item;
      if (this.editingitem.sellerId) {
        this.editingitem.seller = item.sellerId.uid;
        this.getProduct(item.sellerId.uid);
      }
      if (this.editingitem.productId)
        this.editingitem.product = item.productId._id;
      // this.editingitem.startingDate = this.editingitem.starting.slice(0, 10);
      // this.editingitem.endingDate = this.editingitem.ending.slice(0, 10);
      // this.editingitem.startingTime = this.editingitem.starting.slice(11, 16);
      // this.editingitem.endingTime = this.editingitem.ending.slice(11, 16);
      this.editdialog = true;
    },
    deleteItem(r) {
      let getURL;
      if (this.$route.query.Type == "grocerydeals") {
        getURL = "/grocery/admin/delete/deal";
      }
      //  else if (this.$route.query.Type == "SmallBanner") {
      //   getURL = "/grocery/small/banner/delete";
      // } else if (this.$route.query.Type == "ProductBanner") {
      //   getURL = "/grocery/product/banner/delete";
      // } else {
      //   getURL = "/grocery/bottam/banner/delete";
      // }
      this.appLoading = true;
      axios({
        url: getURL,
        method: "POST",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          id: r._id,
        },
      })
        .then((response) => {
          this.delete = false;
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Delete Sucessfully";
            this.showSnackbar = true;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showSnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    dialogclose() {
      this.link = null;
      this.dialog = false;
    },

    uploadImage(id) {
      let getURL;
      if (this.$route.query.Type == "grocerydeals") {
        getURL = "/grocery/admin/upload/deal/image";
      }
      // else if (this.$route.query.Type == "SmallBanner") {
      //   getURL = "/grocery/admin/small/banner/edit";
      // } else if (this.$route.query.Type == "ProductBanner") {
      //   getURL = "/grocery/admin/product/banner/edit";
      // } else {
      //   getURL = "/grocery/admin/bottom/banner/edit";
      // }

      let formData = new FormData();
      formData.append("id", id);
      formData.append("offerImage", this.DealImage);
      axios({
        method: "POST",
        url: getURL,
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.getData();
            this.offerImage = null;
            this.showSnackbar = true;
            this.msg = "Uploaded Successfully";
            this.dialog = false;
            this.DealImage = null;
          } else {
            this.msg = "Can't Update";
            this.showSnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    formatDate(item) {
      var dt = new Date(item);
      var year = dt.getFullYear();
      dt = dt.toString();
      var strTime = dt.slice(4, 10) + " " + year;
      return strTime;
    },
    formatTime(item) {
      if (!item) return;
      var hours = Number(item.split(":")[0]);
      var minutes = Number(item.split(":")[1]);
      var ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes + " " + ampm;
      return strTime;
    },
  },
};
</script>